import 'debug';
import { m as _toConsumableArray } from './index2.js';
import 'deepmerge';
import 'axios';
import Vue from 'vue';

var DynamicPageInPage = Vue.extend({
  name: 'DynamicPageInPage',
  props: {
    pageData: {
      type: Object,
      required: true
    }
  },
  computed: {
    dynamicPage: function dynamicPage() {
      switch (this.pageData.Class) {
        case 'XpSplashScreen':
          return 'XpSplashScreenPage';

        case 'XpSelectLanguage':
          return 'XpSelectLanguagePage';

        case 'XpHome':
          throw new Error('Home page cannot be under home page');

        case 'XpMenu':
          return 'XpMenuPage';

        case 'XpMap':
          return 'XpMapPage';

        case 'XpMultipleChoice':
          return 'XpMultipleChoicePage';

        case 'XpNfc':
          return 'XpNfcPage';

        case 'XpNumericInput':
          return 'XpNumericInputPage';

        case 'XpError':
          return 'XpErrorPage';

        default:
          return 'XpPage';
      }
    },
    enterActiveClass: function enterActiveClass() {
      if (this.$xp.navigation.entryNavDirection === 'previous') {
        return 'animated fadeInLeftBig';
      } else if (this.$xp.navigation.entryNavDirection === 'next') {
        return 'animated fadeInRightBig';
      } else {
        return 'animated fadeIn';
      }
    },
    leaveActiveClass: function leaveActiveClass() {
      if (this.$xp.navigation.entryNavDirection === 'previous') {
        return 'animated fadeOutRightBig';
      } else if (this.$xp.navigation.entryNavDirection === 'next') {
        return 'animated fadeOutLeftBig';
      } else {
        return 'animated fadeOut';
      }
    }
  },
  methods: {
    getPageClasses: function getPageClasses() {
      return {
        'o-page-in-page': true,
        'is-padded-for-nav': !this.pageData.isNavOverlapping,
        'is-full-screen': this.$xp.navigation.isFullScreen
      };
    },
    renderSections: function renderSections(h) {
      var _this = this;

      // <xp-section v-for="section in pageData.Sections" :key="section.ID">
      //   <transition-group
      //   v-if="$xp.navigation.isFullScreen"
      //   :enter-active-class="enterActiveClass"
      //   :leave-active-class="leaveActiveClass"
      //   :duration="{ enter: 200, leave: 200 }">
      //     <dynamic-entry
      //       v-for="(entry, index) in section.entries"
      //       :key="entry.ID"
      //       v-show="(!$xp.navigation.currentEntry && index === 0) || $xp.navigation.currentEntry === 'entry-' + entry.ID"
      //       :entryData="entry"
      //       :localPageData="pageData"
      //       :id="'entry-' + entry.ID"></dynamic-entry>
      //   </transition-group>
      //   <dynamic-entry v-else v-for="entry in section.entries" :entryData="entry" :localPageData="pageData" :key="entry.ID" :id="'entry-' + entry.ID"></dynamic-entry>
      // </xp-section>
      return this.pageData.Sections.map(function (section) {
        return h('xp-section', {
          key: section.ID
        }, [_this.$xp.navigation.isFullScreen ? h('transition-group', {
          props: {
            'enter-active-class': _this.enterActiveClass,
            'leave-active-class': _this.leaveActiveClass,
            duration: {
              enter: 200,
              leave: 200
            }
          }
        }, section.entries.map(function (entry, index) {
          return h('dynamic-entry', {
            key: entry.ID,
            style: !_this.$xp.navigation.currentEntry && index === 0 || _this.$xp.navigation.currentEntry === 'entry-' + entry.ID ? {} : {
              display: 'none'
            },
            props: {
              entryData: entry,
              localPageData: _this.pageData
            },
            attrs: {
              id: 'entry-' + entry.ID
            }
          });
        })) : section.entries.map(function (entry) {
          return h('dynamic-entry', {
            key: entry.ID,
            props: {
              entryData: entry,
              localPageData: _this.pageData
            },
            attrs: {
              id: 'entry-' + entry.ID
            }
          });
        })]);
      });
    },
    renderEntryNav: function renderEntryNav(h) {
      var _this2 = this;

      // <a v-if="$xp.navigation.isEntryNavVisible" :class="{'o-page__previous-entry': true, 'is-hidden': $xp.navigation.isNavHidden || !this.$xp.navigation.hasPreviousEntry}" @click.prevent="$xp.navigation.goToPreviousEntry" >
      //   <span class="xp xp-chevron-left xp--large link"></span>
      // </a>
      // <a v-if="$xp.navigation.isEntryNavVisible" :class="{'o-page__next-entry': true, 'is-hidden': $xp.navigation.isNavHidden || !this.$xp.navigation.hasNextEntry}" @click.prevent="$xp.navigation.goToNextEntry" >
      //   <span class="xp xp-chevron-right xp--large link"></span>
      // </a>
      return this.$xp.navigation.isEntryNavVisible ? [h('a', {
        class: {
          'o-page__previous-entry': true,
          'is-hidden': this.$xp.navigation.isNavHidden || !this.$xp.navigation.hasPreviousEntry
        },
        on: {
          click: function click() {
            return _this2.$xp.navigation.goToPreviousEntry();
          }
        }
      }, [h('span', {
        class: 'xp xp-chevron-left xp--large link'
      })]), h('a', {
        class: {
          'o-page__next-entry': true,
          'is-hidden': this.$xp.navigation.isNavHidden || !this.$xp.navigation.hasNextEntry
        },
        on: {
          click: function click() {
            return _this2.$xp.navigation.goToNextEntry();
          }
        }
      }, [h('span', {
        class: 'xp xp-chevron-right xp--large link'
      })])] : [];
    }
  },
  render: function render(h) {
    // <component v-if="pageData.ID" :is="dynamicPage" :localPageData="pageData" :key="pageData.ID" :class="{'o-page-in-page': true, 'is-padded-for-nav': !pageData.isNavOverlapping, 'is-full-screen': pageData.isFullScreen}">
    // </component>
    return this.pageData.ID ? h(this.dynamicPage, {
      props: {
        localPageData: this.pageData
      },
      class: this.getPageClasses(),
      key: this.pageData.ID
    }, [].concat(_toConsumableArray(this.renderSections(h)), _toConsumableArray(this.renderEntryNav(h)))) : null;
  }
});

export default DynamicPageInPage;
